import {
  FETCH_DELIVERY_CONFIG,
  FETCH_DELIVERY_CONFIG_SUCCESS,
  FETCH_DELIVERY_CONFIG_FAILED,
  EDIT_DELIVERY_CONFIG
} from "../store/types";
import { firebase } from '../config/configureFirebase';
import { onValue, remove, push, update } from "firebase/database";

export const fetchDeliveryConfig = () => (dispatch) => {
  const {
    deliveryParcelTypesRef,
    deliveryOptionsRef,
    deliveryCancelSlabsRef,
    carTypesRef
  } = firebase;

  dispatch({
    type: FETCH_DELIVERY_CONFIG,
    payload: null
  });

  // Listener for Parcel Types
  onValue(deliveryParcelTypesRef, snapshot => {
    let parcelTypes = [];
    if (snapshot.val()) {
      let data = snapshot.val();
      parcelTypes = Object.keys(data).map(i => {
        data[i].id = i;
        return data[i];
      });
    } else {
      // Auto-seed from existing cartypes if delivery_parcel_types is empty
      onValue(carTypesRef, carSnap => {
        if (carSnap.val()) {
          let cars = carSnap.val();
          let uniqueMap = {};
          Object.keys(cars).forEach(k => {
            if (Array.isArray(cars[k]?.parcelTypes)) {
              cars[k].parcelTypes.forEach(pt => {
                if (pt && pt.description && !uniqueMap[pt.description]) {
                  uniqueMap[pt.description] = true;
                  push(deliveryParcelTypesRef, {
                    description: pt.description,
                    amount: parseFloat(pt.amount) || 0
                  });
                }
              });
            }
          });
        }
      }, { onlyOnce: true });
    }

    // Listener for Options
    onValue(deliveryOptionsRef, optSnap => {
      let options = [];
      if (optSnap.val()) {
        let optData = optSnap.val();
        options = Object.keys(optData).map(i => {
          optData[i].id = i;
          return optData[i];
        });
      } else {
        // Auto-seed from existing cartypes if delivery_options is empty
        onValue(carTypesRef, carSnap => {
          if (carSnap.val()) {
            let cars = carSnap.val();
            let uniqueOptMap = {};
            Object.keys(cars).forEach(k => {
              if (Array.isArray(cars[k]?.options)) {
                cars[k].options.forEach(opt => {
                  if (opt && opt.description && !uniqueOptMap[opt.description]) {
                    uniqueOptMap[opt.description] = true;
                    push(deliveryOptionsRef, {
                      description: opt.description,
                      amount: parseFloat(opt.amount) || 0
                    });
                  }
                });
              }
            });
          }
        }, { onlyOnce: true });
      }

      // Listener for Cancellation Slabs
      onValue(deliveryCancelSlabsRef, slabSnap => {
        let cancelSlabs = [];
        if (slabSnap.val()) {
          let slabData = slabSnap.val();
          cancelSlabs = Object.keys(slabData).map(i => {
            slabData[i].id = i;
            return slabData[i];
          });
        } else {
          // Auto-seed from existing cartypes if delivery_cancel_slabs is empty
          onValue(carTypesRef, carSnap => {
            if (carSnap.val()) {
              let cars = carSnap.val();
              let uniqueSlabMap = {};
              Object.keys(cars).forEach(k => {
                if (Array.isArray(cars[k]?.cancelSlab)) {
                  cars[k].cancelSlab.forEach(slb => {
                    let key = `${slb.minsDelayed}_${slb.amount}`;
                    if (slb && !uniqueSlabMap[key]) {
                      uniqueSlabMap[key] = true;
                      push(deliveryCancelSlabsRef, {
                        minsDelayed: parseFloat(slb.minsDelayed) || 0,
                        amount: parseFloat(slb.amount) || 0
                      });
                    }
                  });
                }
              });
            }
          }, { onlyOnce: true });
        }

        dispatch({
          type: FETCH_DELIVERY_CONFIG_SUCCESS,
          payload: {
            parcelTypes,
            options,
            cancelSlabs
          }
        });
      }, error => {
        dispatch({
          type: FETCH_DELIVERY_CONFIG_FAILED,
          payload: error.message
        });
      });
    }, error => {
      dispatch({
        type: FETCH_DELIVERY_CONFIG_FAILED,
        payload: error.message
      });
    });
  }, error => {
    dispatch({
      type: FETCH_DELIVERY_CONFIG_FAILED,
      payload: error.message
    });
  });
};

export const editDeliveryConfigItem = (type, item, method) => async (dispatch) => {
  const {
    deliveryParcelTypesRef,
    deliveryParcelTypesEditRef,
    deliveryOptionsRef,
    deliveryOptionsEditRef,
    deliveryCancelSlabsRef,
    deliveryCancelSlabsEditRef
  } = firebase;

  dispatch({
    type: EDIT_DELIVERY_CONFIG,
    payload: { type, item, method }
  });

  let targetRef, targetEditRef;
  if (type === 'parcelTypes') {
    targetRef = deliveryParcelTypesRef;
    targetEditRef = deliveryParcelTypesEditRef;
  } else if (type === 'options') {
    targetRef = deliveryOptionsRef;
    targetEditRef = deliveryOptionsEditRef;
  } else if (type === 'cancelSlabs') {
    targetRef = deliveryCancelSlabsRef;
    targetEditRef = deliveryCancelSlabsEditRef;
  }

  if (!targetRef) return;

  let cleanItem = { ...item };
  delete cleanItem.id;
  delete cleanItem.tableData;

  if (type === 'cancelSlabs') {
    cleanItem.minsDelayed = parseFloat(cleanItem.minsDelayed) || 0;
    cleanItem.amount = parseFloat(cleanItem.amount) || 0;
  } else {
    cleanItem.amount = parseFloat(cleanItem.amount) || 0;
  }

  if (method === 'Add') {
    push(targetRef, cleanItem);
  } else if (method === 'Update' && item.id) {
    update(targetEditRef(item.id), cleanItem);
  } else if (method === 'Delete' && item.id) {
    remove(targetEditRef(item.id));
  }
};
